<template>
  <a-modal :title="null" :centered="true" :mask-closable="true" @cancel="cancelAction" :closable="false" :visible="visible" :footer="null" :width="900" :body-style="{'padding':'0px', 'borderRadius':'4px'}">
    <div style="width: 100%;height: 54px;text-align: center;background: rgba(99, 171, 205, 0.06);border: 1px solid #E4E7EA;border-top-right-radius: 4px; border-top-left-radius:4px;">
      <span style="font-size: 18px;line-height:54px;font-family: Alibaba PuHuiTi;font-weight: 400;color: #525252;">药品详情</span>
      <a-button type="link" style="position: absolute; right: 24px; line-height: 56px;" @click="cancelAction">X 关闭</a-button>
    </div>
    <div style="max-height: 500px;overflow-y: auto;">
      <a-descriptions :title="null" bordered size="default" :column="{ xxl: 3, xl: 3, lg: 3, md: 3, sm: 2, xs: 1 }">
        <a-descriptions-item label="药品名称">
          {{(record.name||'')}}
        </a-descriptions-item>
        <a-descriptions-item label="所属类型">
          {{(record.typeName||'')}}
        </a-descriptions-item>
        <a-descriptions-item label="药品剂型">
          {{(record.formName||'')}}
        </a-descriptions-item>
        <a-descriptions-item label="药品别名" :span="3">
          {{(record.alias||[]).join('、')}}
        </a-descriptions-item>
        <a-descriptions-item label="生产厂家">
          {{(record.manufacturer||'')}}
        </a-descriptions-item>
        <a-descriptions-item label="药品规格">
          {{(record.spec||'')}}
        </a-descriptions-item>
        <a-descriptions-item label="批准文号">
          {{(record.approval||'')}}
        </a-descriptions-item>
        <a-descriptions-item label="药品销售" :span="2">
          {{(record.price||0.0).toFixed(2)}}元/{{(record.salesUnit|| {name:''}).name}} &nbsp; {{(record.scattered?('拆零销售:'+((record.minPrice||0.0).toFixed(2)+'元/'+(record.minUnit|| {name:''}).name)):'')}}
        </a-descriptions-item>
        <a-descriptions-item label="推荐剂量">
          {{(record.dosage != undefined && record.dosage != null)?(record.dosage.start+record.dosage.unit.name+' - '+record.dosage.end+record.dosage.unit.name):''}}
        </a-descriptions-item>
        <a-descriptions-item label="是否有毒">
          {{(record.toxic?'有毒':'无')}}
        </a-descriptions-item>
        <a-descriptions-item label="用药禁忌">
          {{((record.caution||'') != '')?(record.caution ==='PREGNANCY_CAUTION'?'妊娠慎用':'妊娠禁用'):''}}
        </a-descriptions-item>
        <a-descriptions-item label="当前库存">
          {{(record.stockQty||'')}}
        </a-descriptions-item>
        <a-descriptions-item label="名称解释" :span="3">
          {{(record.explain||'')}}
        </a-descriptions-item>
        <a-descriptions-item label="性状" :span="3">
          {{(record.trait||'')}}
        </a-descriptions-item>
        <a-descriptions-item label="性味" :span="3">
          {{(record.flavour||'')}}
        </a-descriptions-item>
        <a-descriptions-item label="功能" :span="3">
          {{(record.functions||'')}}
        </a-descriptions-item>
        <a-descriptions-item label="主治" :span="3">
          {{(record.indications||'')}}
        </a-descriptions-item>
        <a-descriptions-item label="用法" :span="3">
          {{(record.usage||'')}}
        </a-descriptions-item>
      </a-descriptions>
      <a-row>
        <a-col :xxl="12" :xl="12" :lg="12" :md="12" :sm="12" :xs="24" style="justify-content: center;display:grid;">
          <span style="margin-top: 12px; margin-bottom: 12px;text-align: center;">植物图片</span>
          <img v-if="(undefined != record.botany && null != record.botany && '' != record.botany.url)" :src="record.botany.url"  @click="showFullImg(record.botany.url)" width="125px" height="125px"/>
          <a-empty v-else :image="emptyImage"></a-empty>
        </a-col>
        <a-col :xxl="12" :xl="12" :lg="12" :md="12" :sm="12" :xs="24" style="justify-content: center;display:grid;">
          <span style="margin-top: 12px; margin-bottom: 12px;text-align: center;">草本图片</span>
          <img v-if="(undefined != record.herbal && null != record.herbal && '' != record.herbal.url)" :src="record.herbal.url"  @click="showFullImg(record.herbal.url)" width="125px" height="125px"/>
          <a-empty v-else :image="emptyImage"></a-empty>
        </a-col>
      </a-row>
      <a-row>
        <a-col>
          <a-form-item :colon="false" label="假伪药图片" :label-col="{sm: 24, md: 12, lg: 3, xl: 3, xxl: 3 }"
                       :wrapper-col="{sm: 24, md: 12, lg: 21, xl: 21, xxl: 21 }">
            <template v-if="(undefined != record.falses && null != record.falses && record.falses.length > 0)">
              <img v-for="(item, index) in record.falses" :src="item.url" :key="'img-'+(index+1)" width="125px" height="125px" @click="showFullImg(item.url)">
            </template>
            <a-empty v-else :image="emptyImage"></a-empty>
          </a-form-item>
        </a-col>
      </a-row>
    </div>
  </a-modal>
</template>

<script>
import Vue from 'vue'
import { Empty } from 'ant-design-vue';
import hevueImgPreview from 'hevue-img-preview';
Vue.use(hevueImgPreview);
export default {
  name: "DrugModal",
  data(){
    return{
      visible:false,
      emptyImage:Empty.PRESENTED_IMAGE_SIMPLE,
      record:{}
    }
  },
  methods:{
    showFullImg: function (url) {
      this.$hevueImgPreview({
        url: url,
        mainBackground: 'rgba(0, 0, 0, .5)', // 整体背景颜色
      });
    },
    cancelAction:function (){
      this.visible=false;
      this.record={};
    },
    showDrugModal:function (id){
      const self = this;
      this.$axios.get('/api/clinic/drug/'+id).then(function(res){
        if(res.msg.flag == 0){
          self.record = res.biz;
          self.visible =true;
        }else{
          self.$message.error({content: res.msg.message, duration: 2});
        }
      },function(){
      });
    }
  }
}
</script>

<style scoped>

</style>